import ConfirmDialog from '@/components/ConfirmDialog.vue';
import ConfirmSaveDialog from '@/components/ConfirmSaveDialog.vue';
import UiParentCard from '@/components/UiParentCard.vue';
import ScheduleParentCard from '@/components/ScheduleParentCard.vue';
import AdvanceFilter from '@/components/filterDialog/AdvanceFilter.vue';
import Preloader from '@/components/Preloader.vue';
import Alert from '@/components/Alert.vue';
import DragAndDrop from '@/components/DragAndDrop.vue';
import BsDateField from '@/components/form/BsDateField.vue';
// Registered globally: the "From Computer / From Storage" picker is going into
// every upload point in the app, so page components shouldn't each have to wire
// it up.
import StorageFilePicker from '@/components/storage/StorageFilePicker.vue';

export function Components(app) {
    app
        // .component('breadcrumb', Breadcrumb)
        .component('UiParentCard', UiParentCard)
        .component('ScheduleParentCard', ScheduleParentCard)
        .component('AdvanceFilter', AdvanceFilter)
        .component('confirm-dialog', ConfirmDialog)
        .component('confirmsave-dialog', ConfirmSaveDialog)
        .component('preloader', Preloader)
        .component('alert', Alert)
        .component('DragAndDrop', DragAndDrop)
        .component('StorageFilePicker', StorageFilePicker)
        .component('BsDateField', BsDateField)
        .component('bs-date-field', BsDateField);
}
